export default class poster {
   constructor(el){
      this.el = el;
      this.images = $(el).find('img');

      console.log(this.images);

      var par = this;

      // $(this.images).each(function(){
      //    let objectPos = $(this).css('object-position')||'50% 50%';
      //    objectPos = objectPos.split(' ');
      //    let x = objectPos[0];
      //    let y = objectPos[1];
      //    $(this).parent().css({
      //       'object-position': '',
      //       'transform' : `translate3d(-${x}, -${y}, 0)`,
      //    });
      //    $(this).css('object-position','');
      //                //  console.log(x);
      //    if($(this).parent().hasClass('ver')) {
      //       let w = 100 + (Math.abs(50 - Math.abs(parseInt(x))) * 3);
      //       w < 100 ? w = 120 : w = w;
      //       $(this).parent().css({
      //          'width' : `${w}%`
      //       });
      //    }
      // });
      
      $(el).find('.poster--wrap').addClass('in');

      // $(window).on('pageshow', function(){
         var img = new Image();
         $(img).on('load', function() {
            $('.poster--wrap').addClass('in');
         });
         
         if($(this.images).get(0)) {
            img.src = $(this.images).get(0).currentSrc;
         }
      // });

      setTimeout(function(){
         $(par.el).find('.poster--wrap').addClass('in');
      }, 1500);

      $(window).on('scroll', function(){
         var transPx = $(window).scrollTop() * 0.3;
         $(par.el).css({
            'transform' : `translateY(${-transPx}px)`
         });
      });
   }
}